export const RECOMMENDATION_FEE_CZK = 300;
